<div class="login-container" dir="ltr">
  <div class="left-side">
    <img
      src="assets/images/account/afra-school.svg"
      alt="Afra"
      class="hand-heart-img"
    />
    <div class="card-wrapper">
      <img src="assets/images/account/leaf.svg" alt="Star" class="star-img" />
      <img
        src="assets/images/account/diamond.svg"
        alt="Star"
        class="star-img-2"
      />
      <div class="blur-card"></div>
    </div>
  </div>
  <div class="right-side" dir="rtl">
    <div class="content">
      <div class="flex flex-column gap-2 items-center">
        <div class="display-6 ms-0 me-2">
          <img
            src="/assets/images/afra-school-colorful.svg"
            alt="لوگوی افرا"
            style="height: 58px"
          />
        </div>
        <div class="text-2xl mt-4 font-bold" routerLink="/">
          {{ systemNameLabel }}
        </div>
        <div class="alert alert-warning mt-3">
          <ng-icon class="me-2" name="lucideTriangleAlert"></ng-icon>
          ورود به این بستر فقط برای اعضا و داوطلبان سازمان‌های نیکوکاری و
          مردم‌نهاد است. برای دسترسی به امکانات مدرسه، در مرحله بعد باید سازمان
          نیکوکاری خود را انتخاب کنید.
        </div>
        <form dir="ltr" class="mt-4" class="w-100">
          <div *ngIf="showMobileForm">
            <form [formGroup]="mobileForm">
              <input
                arabicNumber
                type="tel"
                maxlength="11"
                autocomplete="tel"
                pInputText
                fluid
                (keyup)="onMobileNumberInputKeyUp($event)"
                formControlName="mobileNumber"
              />
              <div class="mt-2">
                <small class="text-secondary"
                  >.شماره تلفن همراه را با فرمت _________09 وارد کنید</small
                >
              </div>
              <div
                class="alert alert-warning mt-3"
                style="direction: rtl"
                *ngIf="vpnWarningLabel"
              >
                <ng-icon name="lucideTriangleAlert" class="fs-4"></ng-icon>
                {{ vpnWarningLabel }}
              </div>
              <button
                type="submit"
                pButton
                class="w-100 mt-2"
                [disabled]="!mobileForm.valid"
                (click)="onGetOTPButton()"
              >
                {{ getOTPLabel }}
              </button>
            </form>
            <div class="text-center mt-4">
              <div>
                <a
                  href="https://afraway.org/ws"
                  target="_blank"
                  class="link-success"
                  >راهنمای ثبت‌نام در کارگاه‌ها</a
                >
              </div>
              <div class="mt-2">
                شماره تماس:
                <span class="ms-1"
                  ><a class="link-success" href="tel:02191002372"
                    >02191002372</a
                  ></span
                >
                <span class="ms-2">داخلی ۱</span>
              </div>
            </div>
          </div>
          <div *ngIf="showOTPForm">
            <div class="mb-2" style="direction: rtl">
              <small class="text-secondary">{{ OTPBoxLabel }}</small>
            </div>
            <form [formGroup]="otpForm">
              <input
                arabicNumber
                type="tel"
                maxlength="4"
                pInputText
                fluid
                (keyup)="onOTPInputKeyUp($event)"
                formControlName="otpCode"
              />
              <div
                class="alert alert-warning mt-3"
                style="direction: rtl"
                *ngIf="vpnWarningLabel"
              >
                <ng-icon name="lucideTriangleAlert"></ng-icon>
                {{ vpnWarningLabel }}
              </div>
              <button
                type="button"
                pButton
                class="w-100 mt-3"
                [disabled]="!otpForm.valid"
                (click)="onLogin()"
              >
                {{ loginLabel }}
              </button>
            </form>
            <button
              type="button"
              pButton
              severity="secondary"
              class="w-100 mt-3"
              [disabled]="leftSeconds != null"
              (click)="onGetOTPAgainButton()"
            >
              {{ leftSeconds != null ? leftTimeLabel : getOTPAgainLabel }}
            </button>
            <button
              type="button"
              pButton
              severity="secondary"
              class="w-100 mt-1"
              (click)="onChangeMobileNumberButton()"
            >
              {{ changeMobileLabel }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
